import React from 'react';
import DefaultRouteNavigationHeaderLeft from '@/components/Navigation/Routes/DefaultRouteNavigationHeaderLeft';

// Function to get navigation options - hides header on desktop
const getFilesRouteNavigationOptions = (isXS) => ({
  title: 'Files',
  headerTitle: isXS ? 'Files' : '',
  headerShown: isXS, // Hide entire header on desktop
  headerBackVisible: false,
  headerLeft: () => <DefaultRouteNavigationHeaderLeft forceSidebarToggle />,
});

// Default export for backwards compatibility (mobile gets title)
const FilesRouteNavigationOptions = {
  title: 'Files',
  headerTitle: 'Files',
  headerBackVisible: false,
  headerLeft: () => <DefaultRouteNavigationHeaderLeft forceSidebarToggle />,
};

export { getFilesRouteNavigationOptions };
export default FilesRouteNavigationOptions;
